import siteTheme from 'styles/theme'

const fontSizes = {
  large: '0.75rem', // 12px
} as const

const theme = {
  /* Color palette */
  palette: {
    negative: siteTheme.colors.red,
  },
  fontSizes,
}

export const errorStyles = `
  color: ${theme.palette.negative};
  font-size: ${theme.fontSizes.large};
`

export default theme
